import { Link } from "react-router-dom";
import { Button } from "@/components/Button";

export default function NotFound() {
  return (
    <section className="bg-canvas py-28 lg:py-40" data-testid="not-found-page">
      <div className="mx-auto max-w-2xl px-4 sm:px-6 text-center">
        <span className="font-display text-amber text-7xl font-bold">404</span>
        <h1 className="mt-4 font-display uppercase text-3xl sm:text-4xl tracking-wide text-ink">Page Not Found</h1>
        <p className="mt-4 text-muted">
          The page you're looking for doesn't exist or has moved. Try our parts catalogue or head back home.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Button to="/" variant="primary" data-testid="not-found-home-btn">Back to Home</Button>
          <Link to="/parts" className="inline-flex items-center border border-ink/25 px-6 py-3 text-sm font-semibold text-ink transition-colors hover:bg-ink hover:text-white" data-testid="not-found-parts-btn">
            Browse Parts
          </Link>
        </div>
      </div>
    </section>
  );
}
